import { ChangeEvent } from "react";

import CustomInput from "./CustomInput";
import DateInput from "./DateInput";

type DateValue = {
  id: string;
  name: string;
  value: string;
};

type DateRangeInputProps = {
  id?: string;
  values: {
    from: DateValue;
    to: DateValue;
  };
  label?: string;
  onChangeDate: Function;
  isClearable?: boolean;
};

const DateRangeInput = (props: DateRangeInputProps) => {
  const { id, values, label, onChangeDate, isClearable } = props;

  const onRangeChange = (
    newStartDate: Date | string | undefined,
    newEndDate: Date | string | undefined
  ) => {
    onChangeDate({
      [values.from.id]: newStartDate || values.from.value,
      [values.to.id]: newEndDate || values.to.value,
    });
  };

  const onClearRange = () => {
    onChangeDate({
      [values.from.id]: "",
      [values.to.id]: "",
    });
  };

  return (
    <CustomInput
      id={id}
      label={label}
      onClear={
        isClearable && (values.from.value || values.to.value)
          ? onClearRange
          : undefined
      }
    >
      <div className="CustomInput__dateRange">
        <DateInput
          onChange={(e: ChangeEvent<HTMLInputElement>) => {
            onRangeChange(e.target.value, undefined);
          }}
          {...values.from}
          maxDate={values.to.value}
          placeholder="From"
          showPickerOnFocus
        />
        <DateInput
          onChange={(e: ChangeEvent<HTMLInputElement>) => {
            onRangeChange(undefined, e.target.value);
          }}
          {...values.to}
          minDate={values.from.value}
          placeholder="To"
          showPickerOnFocus
        />
      </div>
    </CustomInput>
  );
};

export default DateRangeInput;
